import React, { useState } from "react";

// Colour tokens — mirrors App.js C object (passed as prop to avoid coupling)
export default function SourceCard({ source, C }) {
  const [expanded, setExpanded] = useState(false);

  if (!source) return null;

  // Aggregate cards lead with the legible facts — how many people answered and
  // which way their tone leaned — rather than an abstract 0-100 index.
  const respWord = source.n === 1 ? "response" : "responses";
  const buckets = [
    { k: "positive", v: source.positive },
    { k: "neutral",  v: source.neutral },
    { k: "negative", v: source.negative },
  ].filter(b => b.v != null);
  const dominant = buckets.length ? buckets.reduce((a, b) => (b.v > a.v ? b : a)) : null;

  const label = source.type === "aggregate"
    ? `Q${source.questionIndex + 1} · ${source.n} ${respWord}${dominant ? ` · ${dominant.v}% ${dominant.k}` : ""}`
    : source.type === "transcript"
    ? `Q${source.questionIndex + 1} · ${source.sentiment || "neutral"} response`
    : "Data source";

  return (
    <div
      onClick={() => setExpanded(e => !e)}
      style={{
        display: "inline-flex", flexDirection: "column", gap: 4,
        padding: "4px 10px", borderRadius: 8, cursor: "pointer",
        background: expanded ? "rgba(139,92,246,0.12)" : "rgba(139,92,246,0.06)",
        border: `1px solid ${expanded ? C.purple : "rgba(139,92,246,0.2)"}`,
        fontSize: 11, color: C.muted, transition: "all 0.15s",
      }}
    >
      <span style={{ color: C.purple, fontWeight: 600 }}>
        {source.type === "aggregate" ? "📊" : "💬"} {label}
      </span>
      {expanded && source.type === "transcript" && source.excerpt && (
        <span style={{ color: C.text, fontStyle: "italic", marginTop: 2, lineHeight: 1.5 }}>
          "{source.excerpt}"
        </span>
      )}
      {expanded && source.type === "aggregate" && (
        <span style={{ color: C.text, marginTop: 2, lineHeight: 1.5 }}>
          {source.questionText && (
            <span style={{ display: "block", fontStyle: "italic", marginBottom: 4 }}>
              "{source.questionText}"
            </span>
          )}
          Positive {source.positive ?? "—"}% · Neutral {source.neutral ?? "—"}% · Negative {source.negative ?? "—"}%
        </span>
      )}
    </div>
  );
}
